import { render } from "./billCheckReport.vue?vue&type=template&id=2cba9483"
import script from "./billCheckReport.vue?vue&type=script&lang=js"
export * from "./billCheckReport.vue?vue&type=script&lang=js"

import "./billCheckReport.vue?vue&type=style&index=0&id=2cba9483&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__